<template>
  <div class="main-content sn-content">

  <!--  <el-card class="box-card clearfix">-->
    <el-row style="margin-bottom: 15px;background: #f4f4f5;padding: 15px 15px 0 0">
      <el-col :xs="12" :sm="14">
      <el-form class="search-form" ref="form" :model="searchForm" v-if="!$route.query.userId">
        <el-form-item label="状态：" label-width="85px">
          <el-select v-model="searchForm.status"
                     @change="statusChangeFn"
                     placeholder="" style="width:120px">
            <el-option
              v-for="(item) in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-input v-model="searchForm.orderId" placeholder="请输入订单号" >
            <el-button slot="append" @click="getSDKlicence" icon="el-icon-search"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      </el-col>
      <el-col :xs="12" :sm="10" justify="end">
        <!-- <router-link v-if="parseInt(userQuotaForAppli.quota) > parseInt(appliCnt) " :to="{path:'/appli/add'}"
                    style="color: #435465;float: right">
           添加应用
         </router-link>-->
        <router-link :to="{path:'/price/index',query: {from: 'sdk'} }" class="pvt-color"
                     style="float: right">
          价格详情
        </router-link>
        <el-button class="pvt-color" type="text" style="float: right;padding: 0;marginRight:20px;" @click="gotoSdkAdd()">
          创建sdk授权码
        </el-button>
      </el-col>
    </el-row>
      <el-table
        :data="sdkLicenceList">

        <template slot="empty">
          <el-button @click="gotoSdkAdd()"
                     type="text"
                     size="small"
                     style="font-size:14px;"
                     class="pvt-color">申请Sdk授权码
          </el-button>
        </template>
        <el-table-column
          prop="sdkId"
          label="SDK授权码" width="300px">
        </el-table-column>
        <el-table-column
          prop="orderId"
          label="订单Id">
        </el-table-column>

        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0"> 有效</span>
            <span class="danger" v-if="scope.row.status == 1"> 无效</span>
          </template>
        </el-table-column>
        <el-table-column
          label="授权类型">
          <template slot-scope="scope">
            <span>{{ scope.row.sdkType | formatSdkType }}  </span>
          </template>
        </el-table-column>
        <el-table-column
          label="行业伙伴免费SDK授权">
          <template slot-scope="scope">
            <span>{{ scope.row.partnerFreeFlag==='Y'? '是': '否' }}  </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          prop="note"
          label="备注">
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="space-between" style="align-items: center;">
        <template v-if="$store.state.voucherBalance && $store.state.voucherBalance != ''">
          <p v-if="userBalance <= 0" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
            <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
              【去充值】
            </router-link>
          </p>
          <div v-else></div>
        </template>
        <template v-else>
          <p v-if="userBalance <= 0" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
            <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
              【去充值】
            </router-link>
          </p>
          <div v-else></div>
        </template>
        <PageComponent ref="pageInfo"></PageComponent>
      </el-row>
<!--    </el-card>-->
  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'

  export default {
    components: {PageComponent},
    data() {
      return {
        sdkLicenceList: [],
        cloudSnCnt: 0,
        userQuotaForSn: {},
        searchForm:{
          status:0,
          orderId:this.$route.query.orderId
        },
        // 状态下拉列表
        statusOptions: [
          {value: '', label: '全部'},
          {value: 0, label: '有效'},
          {value: 1, label: '禁用'},
        ],
        userBalance: this.$store.state.userBalance
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getSDKlicence: function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        if(this.searchForm.orderId != ''){
          params.orderId = this.searchForm.orderId;
        }
        if(this.searchForm.status !=="") params.status = this.searchForm.status;//状态筛选
        this.getRequest('/pocSdkid/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              console.log(resp.data.result.records)
              this.sdkLicenceList = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
              //TODO:查询poc_product表查询具体的配合信息
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      // 查询状态change
      statusChangeFn(val) {
        this.snStatus = val;
        let queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        this.getSDKlicence();
      },
      gotoSdkAdd() {
        this.$router.push({path: '/sdkLicence/add'})
      },
    },
    mounted: function () {
      this.getSDKlicence();
      this.$refs.pageInfo.initPagenator(this.getSDKlicence, null);
    },
    beforeDestroy() {

    }
  }
</script>
<style scoped>
  .balance-tip {
    color:#F56C6C;
  }
</style>
